import cn from 'classnames';
import { type ReactNode, useState } from 'react';
import { SearchVerticalConfig, type Vertical } from 'shared/search/common/config';

import styles from './HeroBanner.module.css';

interface HeroBannerProps {
    vertical: Vertical;
    children?: ReactNode;
    unleash?: Record<string, boolean> | null; // cannot be just undefined as that is not serializable (toggles are returned from getSSP)
}

export const HeroBanner = ({ vertical, unleash, children }: HeroBannerProps) => {
    const [hasError, setHasError] = useState(false);

    const base = 'https://images.finncdn.no/dynamic';
    const defaultImage = `${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg`;

    return (
        <div className={cn('', styles['hero-banner'], styles[`hero-banner--${vertical}`])}>
            {!unleash?.kayakWhitelabel && vertical === SearchVerticalConfig.hotel.vertical ? (
                <p className="flex absolute w-full top-0 p-12 whitespace-nowrap pointer-events-none border border-l-4 rounded-4 s-text bg-[--w-color-callout-background] border-[--w-color-callout-border] z-10">
                    <span className="mr-8 w-icon w-icon--m s-icon-positive">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <title>Konfetti som flyr ut av en kjegle</title>
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M14.31 8.37s0-1.98 1.98-1.98 1.98-1.98 1.98-1.98m-5.94-.66v1.98m5.94 5.94 1.32 1.32m-1.32-3.96 1.98-.66M6.891 10.853l6.256 6.256m-4.356 1.584-3.484-3.484M3.79 19.387 8.121 7.474a.643.643 0 0 1 1.06-.235l7.58 7.581a.643.643 0 0 1-.235 1.059L4.613 20.21a.642.642 0 0 1-.824-.824"
                            />
                        </svg>
                    </span>
                    Heisann! Hotellsøket har nå fått ny drakt. God tur!
                </p>
            ) : null}
            <div
                className={cn(styles['hero-banner__image-wrapper'], styles[`hero-banner__image-wrapper--${vertical}`], {
                    [styles['hero-banner__image-wrapper--error']]: hasError,
                })}>
                <img
                    className={cn(styles['hero-banner__image'], styles[`hero-banner__image--${vertical}`])}
                    srcSet={`
                            ${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg 320w,
                            ${base}/640w_webp/travel/frontpage/herobanner_${vertical}.jpg 640w,
                            ${base}/960w_webp/travel/frontpage/herobanner_${vertical}.jpg 960w,
                            ${base}/1280w_webp/travel/frontpage/herobanner_${vertical}.jpg 1280w
                        `}
                    sizes="100vw"
                    src={defaultImage}
                    onError={() => setHasError(true)}
                    alt=""
                />
            </div>
            <div className={styles['hero-banner__content-wrapper']}>{children}</div>
        </div>
    );
};
